module.exports = __webpack_public_path__ + "media/product/cat-03-7d03ffb3.png";